export const tr = {
  title: 'jbp-partners-without-sob-title',

  columnPartnerId: 'jbp-spt-partner-id-column',
  columnLocationId: 'jbp-spt-location-id-column',
  columnPartnerName: 'jbp-spt-partner-name-column',
  columnMarket: 'jbp-spt-market-column',
  columnCountry: 'jbp-spt-country-column',
  columnHierarchy: 'jbp-spt-hierarchy-column',

  closeButton: 'jbp-partners-without-sob-close',
}
